'use strict';

$(document).ready(function () {

    $('.chart-head__filter').find('.custom-option').on('click', function () {
        if ($(this).data('target') == 'all') {
            $('.fishes li').css('opacity', '1');
            return;
        }
        $('.fishes li').css('opacity', '0');
        $('.' + $(this).data('target')).css('opacity', '1');
    });

    $("#expand-chart").on("click", function () {
        var chart = $('#chart');
        chart.toggleClass('active');
    });
});